<template>
  <div class="mt-10">
    <v-toolbar color="grey lighten-4" light tile flat>
      <v-toolbar-title centered class="headline font-weight-bold"> Activity </v-toolbar-title>
      <div class="flex-grow-1"></div>

      <div>
        <v-btn color="primary" @click="downloadActivites">
          <v-icon>
            mdi-download
          </v-icon>
          Download activities
        </v-btn>
      </div>
    </v-toolbar>
    <v-data-table title="Suspicion Cases" :items.sync="histories" :headers="headers">
      <template slot="item.event" slot-scope="{ item }">
        {{ item.event | title }}
      </template>
      <template slot="item.date" slot-scope="{ item }">
        <div v-if="item.date">
          {{ item.date | date }}
        </div>
      </template>
      <template slot="item.changes.before" slot-scope="{ item }">
        <div v-if="item.changes">
          <div v-for="(value, name) in item.changes.before" :key="name">
            {{ name }}: {{ value }}
          </div>
        </div>
      </template>
      <template slot="item.changes.after" slot-scope="{ item }">
        <div v-if="item.changes">
          <div v-for="(value, name) in item.changes.after" :key="name">{{ name }}: {{ value }}</div>
        </div>
      </template>
      <template slot="item.user && item.user.full_name" slot-scope="{ item }">
        <div v-if="item.user.full_name">
          {{ item.user.full_name | title }}
          <v-chip v-if="item.user.roles.length">{{ item.user.roles[0].name }}</v-chip>
        </div>
      </template>
    </v-data-table>
  </div>
</template>
<script>
export default {
  props: {
    transaction: { required: true, type: Object },
  },
  data() {
    return {
      headers: this.pairTableLabelWithValue({
        Event: "event",
        Date: "date",
        Before: "changes.before",
        After: "changes.after",
        "Updated By": "user.full_name",
      }),
      histories: [],
    };
  },
  mounted() {
    this.orderHistories();
  },
  methods: {
    orderHistories() {
      this.histories = this.transaction.history.sort(function (a, b) {
        if (a.date > b.date) {
          return -1;
        } else if (a.date < b.date) {
          return 1;
        }
        return 0;
      });
    },
    downloadActivites() {
      this.processing = true;
      this.$http
        .get(`api/v1/operations/${this.transaction.id}/download_activities`, {
          responseType: "blob",
        })
        .then((response) => this.convertResponse(response))
        .catch((error) => Notify.errorFromResponse(error, { close: true }))
        .finally(() => {
          this.processing = false;
        });
    },
    convertResponse(response) {
      const blob = new Blob([response], { type: response.type });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "activities-" + this.transaction.id);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    },
  },
};
</script>
